// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1VyXHANVMU9dOu {\n  cursor: pointer;\n}\n._2ED59WIBaPnq1G {\n  font-weight: bold;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineMember": "_1VyXHANVMU9dOu",
	"fontWeightBold": "_2ED59WIBaPnq1G"
};
export default ___CSS_LOADER_EXPORT___;
